__turbopack_context__.v({
  "clamped": "_wEZJq_clamped",
  "color-accent": "_wEZJq_color-accent",
  "color-error": "_wEZJq_color-error",
  "color-info": "_wEZJq_color-info",
  "color-jets-beige": "_wEZJq_color-jets-beige",
  "color-jets-black": "_wEZJq_color-jets-black",
  "color-jets-red": "_wEZJq_color-jets-red",
  "color-link": "_wEZJq_color-link",
  "color-neutral-100": "_wEZJq_color-neutral-100",
  "color-neutral-200": "_wEZJq_color-neutral-200",
  "color-neutral-300": "_wEZJq_color-neutral-300",
  "color-neutral-400": "_wEZJq_color-neutral-400",
  "color-neutral-500": "_wEZJq_color-neutral-500",
  "color-neutral-600": "_wEZJq_color-neutral-600",
  "color-neutral-700": "_wEZJq_color-neutral-700",
  "color-neutral-800": "_wEZJq_color-neutral-800",
  "color-neutral-900": "_wEZJq_color-neutral-900",
  "color-overImage": "_wEZJq_color-overImage",
  "color-overPrimary": "_wEZJq_color-overPrimary",
  "color-primary": "_wEZJq_color-primary",
  "color-primary-highlight": "_wEZJq_color-primary-highlight",
  "color-primary-tint": "_wEZJq_color-primary-tint",
  "color-success": "_wEZJq_color-success",
  "color-warning": "_wEZJq_color-warning",
  "color-white": "_wEZJq_color-white",
  "font-accent": "_wEZJq_font-accent",
  "font-regular": "_wEZJq_font-regular",
  "font-special": "_wEZJq_font-special",
  "lineHeight-large": "_wEZJq_lineHeight-large",
  "lineHeight-standard": "_wEZJq_lineHeight-standard",
  "lineThrough": "_wEZJq_lineThrough",
  "lines-1": "_wEZJq_lines-1",
  "lines-2": "_wEZJq_lines-2",
  "lines-3": "_wEZJq_lines-3",
  "lines-4": "_wEZJq_lines-4",
  "lines-5": "_wEZJq_lines-5",
  "priority-low": "_wEZJq_priority-low",
  "textSize-large": "_wEZJq_textSize-large",
  "textSize-small": "_wEZJq_textSize-small",
  "textSize-standard": "_wEZJq_textSize-standard",
  "textSize-xlarge": "_wEZJq_textSize-xlarge",
  "textSize-xsmall": "_wEZJq_textSize-xsmall",
  "textSize-xxlarge": "_wEZJq_textSize-xxlarge",
  "textSize-xxxlarge": "_wEZJq_textSize-xxxlarge",
  "textWeight-medium": "_wEZJq_textWeight-medium",
  "textWeight-regular": "_wEZJq_textWeight-regular",
  "textWeight-semi-strong": "_wEZJq_textWeight-semi-strong",
  "textWeight-strong": "_wEZJq_textWeight-strong",
  "transform-capitalize": "_wEZJq_transform-capitalize",
  "transform-uppercase": "_wEZJq_transform-uppercase",
  "truncate": "_wEZJq_truncate",
  "visibility-hidden": "_wEZJq_visibility-hidden",
  "whiteSpace-nowrap": "_wEZJq_whiteSpace-nowrap",
  "whiteSpace-pre-line": "_wEZJq_whiteSpace-pre-line",
  "whiteSpace-pre-wrap": "_wEZJq_whiteSpace-pre-wrap",
  "wordWrap-break-word": "_wEZJq_wordWrap-break-word",
});
